import { FEE_MARKET_PROGRAM_TYPES } from '@/constants/marketPrograms'

import { convertToStandardMarketProgramType } from './convertToStandardMarketProgramType'

/**
 * Fee programs (WHOLESALE_FEES, IMBALANCE, BALANCING_FEES) are considered costs. All other
 * market programs — including the remaining BRP billing lines such as DAY_AHEAD — are
 * considered revenues.
 */
export function isFeeMarketProgram(marketProgram: string): boolean {
  const standardType = convertToStandardMarketProgramType(marketProgram)

  return FEE_MARKET_PROGRAM_TYPES.some((feeProgram) => feeProgram === standardType)
}
